import { render, staticRenderFns } from "./masterItems.vue?vue&type=template&id=a226a922&"
import script from "./masterItems.vue?vue&type=script&lang=js&"
export * from "./masterItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports